import type { ClickableProps } from '../Clickable/interfaces';

export enum InfoBoxColor {
  Simple = 'simple',
  Highlighted = 'highlighted',
}

export enum InfoBoxButtonStyle {
  Button = 'button',
  Link = 'link',
}

export enum InfoBoxStyle {
  Centered = 'centered',
  SideBySide = 'side-by-side',
}

export interface InfoBoxBaseProps {
  readonly color: InfoBoxColor;
  readonly boxStyle?: InfoBoxStyle;
  readonly headline?: string;
  readonly text: string;
  readonly buttonLabel?: string;
  readonly buttonStyle?: InfoBoxButtonStyle;
  readonly headlineTag?: `h${1 | 2 | 3 | 4 | 5 | 6}` | 'span' | 'div';
}

export type InfoBoxProps = InfoBoxBaseProps & ClickableProps;
